"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
exports.createLogger = function (debug) {
    var log = function (name, message) {
        var objs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            objs[_i - 2] = arguments[_i];
        }
        if (debug) {
            // tslint:disable-next-line:no-console
            console.log.apply(console, __spreadArrays(["[react-token-auth]" + name + "::" + message], objs.map(function (it) { return JSON.stringify(it); })));
        }
    };
    return {
        log: log,
    };
};
